var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#9269CD",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1476_187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1476_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3332 19V13L18.9998 16L14.3332 19ZM15.9998 23.3333C14.7998 23.3333 13.6749 23.0582 12.6252 22.508C11.5749 21.9582 10.6998 21.1888 9.99984 20.2V22H8.6665V18H12.6665V19.3333H11.0332C11.5998 20.1666 12.3192 20.8195 13.1912 21.292C14.0636 21.764 14.9998 22 15.9998 22C17.2776 22 18.4358 21.6333 19.4745 20.9C20.5136 20.1666 21.2443 19.1944 21.6665 17.9833L22.9665 18.2833C22.4665 19.7944 21.5776 21.014 20.2998 21.942C19.0221 22.8695 17.5887 23.3333 15.9998 23.3333ZM8.69984 15.3333C8.77761 14.5888 8.95539 13.8748 9.23317 13.1913C9.51095 12.5082 9.89428 11.8777 10.3832 11.3L11.3332 12.25C10.9776 12.7055 10.6887 13.1915 10.4665 13.708C10.2443 14.2248 10.1054 14.7666 10.0498 15.3333H8.69984ZM12.2665 11.3166L11.3165 10.3666C11.9054 9.87773 12.5387 9.49151 13.2165 9.20795C13.8943 8.92484 14.5998 8.75551 15.3332 8.69995V10.0333C14.7665 10.0888 14.2276 10.2277 13.7165 10.45C13.2054 10.6722 12.7221 10.9611 12.2665 11.3166ZM19.7498 11.3166C19.2943 10.9611 18.8083 10.6722 18.2918 10.45C17.7749 10.2277 17.2332 10.0888 16.6665 10.0333V8.69995C17.4109 8.76662 18.1247 8.93884 18.8078 9.21662C19.4914 9.4944 20.1221 9.87773 20.6998 10.3666L19.7498 11.3166ZM21.9665 15.3333C21.9109 14.7666 21.7721 14.2248 21.5498 13.708C21.3276 13.1915 21.0387 12.7055 20.6832 12.25L21.6332 11.3C22.1221 11.8777 22.5054 12.5082 22.7832 13.1913C23.0609 13.8748 23.2332 14.5888 23.2998 15.3333H21.9665Z",
    fill: "#9269CD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.22f17258efdca077d877c1f986bb1abf.svg";
export { ForwardRef as ReactComponent };